import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { postIdrCreateTransaction } from "../redux/actions/postQrInitManual";
import { toLocaleStringFormate } from "../helpingFunctions";
import { language } from "../utils/language";
import Qris from "../assets/qrisLogo.svg";
import { Radio, Select, Space } from "antd";
import ButtonWrapper from "./ButtonWrapper";
import LanugageSelector from "./LanugageSelector";
import SpinerIndicatorWhiteBg from "./SpinerIndicatorWhiteBg";
import Ukflag from "../assets/ukflag.png";
import Bahasa from "../assets/bahasa.png";
const { Option } = Select;

const CardWrapper = styled.div`
  height: auto;
  z-index: 999;
  @media (min-width: 280px) and (max-width: 768px) {
    width: 90%;
  }
  width: 30%;
  background: #fff;
  // padding: 20px 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  .card-header {
    background: #162056;
    padding: 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  h3 {
    color: white;
  }
`;

const IdrPaymentMethodSelectCard = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [value, setValue] = useState("");
  const [lang, setLang] = useState("bi");

  const { data, error } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { isLoading } = useSelector((state) => state.postQrInitManualReducer);
  // const { lang } = useSelector((state) => state.languageSelectorReducer);

  const currentURL = window.location.href; // returns the absolute URL of a page
  const getRedictionalUrl = currentURL.split("=")[1];

  const url = new URL(currentURL);
  const redirectionUrl = url.search?.split("Url=")[1];

  let qrManualTransactionParams = {
    transactionId: data.trxRef,
    // type: "qris",
    amount: parseFloat(data?.amount),
    sessionId: data.sessionToken,
    userId: data.merchantId,
  };

  useEffect(() => {
    dispatch({
      type: "GET_REDICTIONAL_URL",
      payLoad: redirectionUrl,
    });
  }, []);

  useEffect(() => {
    if (data) {
      if (
        data.payOptions?.includes("va") &&
        !data.payOptions?.includes("qris")
      ) {
        dispatch(
          postIdrCreateTransaction(
            { ...qrManualTransactionParams, type: "va" },
            navigation,
            params.id
          )
        );
      } else if (
        data.payOptions?.includes("qris") &&
        !data.payOptions?.includes("va")
      ) {
        dispatch(
          postIdrCreateTransaction(
            { ...qrManualTransactionParams, type: "qris" },
            navigation,
            params.id
          )
        );
      }
    }
  }, [data]);

  return (
    <CardWrapper className="">
      {data.payOptions?.includes("qris") && data.payOptions?.includes("va") ? (
        <>
          <div className="card-header w-100">
            <h3 className="text-center">
              {language[lang].idrMethod.selectPaymentMethod}
            </h3>
          </div>

          <div className="w-100 px-4 pb-4">
            <div className="mt-3 d-flex align-items-start justify-content-between">
              <p className=" w-75 text-center mr-2" style={{ lineHeight: 1 }}>
                {/* {language[lang].idrMethod.CARD_DESCRIPTION} */}
              </p>
              <Select
                defaultValue={"bi"}
                value={lang}
                onChange={(e) => setLang(e)}
              >
                {["en", "bi"]?.map((item) => {
                  return (
                    <Option value={item}>
                      <img
                        src={item === "en" ? Ukflag : Bahasa}
                        style={{
                          width: 20,
                        }}
                      />
                    </Option>
                  );
                })}
              </Select>
            </div>

            <Radio.Group
              className="mt-4"
              onChange={(e) => setValue(e.target.value)}
              value={value}
            >
              <Space direction="vertical" className="flex items-center">
                {data.payOptions?.includes("va") ? (
                  <Radio
                    value={data.payOptions?.includes("va") && "va"}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <h1
                      style={{
                        color: "black",
                        fontSize: "3rem",
                        fontWeight: "600",
                      }}
                    >
                      VA
                      <sub
                        style={{
                          fontSize: "1rem",
                          position: "relative",
                          bottom: 3,
                        }}
                      >
                        (Virtual Account)
                      </sub>
                    </h1>
                  </Radio>
                ) : null}
                {data.payOptions?.includes("qris") ? (
                  <Radio value={data.payOptions?.includes("qris") && "qris"}>
                    <img src={Qris} height="50px" alt="qris" />
                  </Radio>
                ) : null}
              </Space>
            </Radio.Group>

            <div className="d-flex mt-5">
              <p className="label fw-bold mb-0">
                {language[lang].idrMethod.amount}*
              </p>
              <p className="label fw-bold mb-0 ms-5">
                {toLocaleStringFormate(data?.amount)}
              </p>
            </div>
            <ButtonWrapper
              onClick={() => {
                if (value === "qris") {
                  dispatch(
                    postIdrCreateTransaction(
                      { ...qrManualTransactionParams, type: "qris" },
                      navigation,
                      params.id
                    )
                  );
                } else if (value === "va") {
                  dispatch(
                    postIdrCreateTransaction(
                      { ...qrManualTransactionParams, type: "va" },
                      navigation,
                      params.id
                    )
                  );
                }
              }}
              size="middle"
              height="40px"
              border={true}
              // htmlType="submit"
              disabled={value ? false : true}
              loading={isLoading}
              className="w-100 mt-4 btn "
              text={language[lang].idrMethod.next}
            />
          </div>
        </>
      ) : (
        <div>
          <SpinerIndicatorWhiteBg
            thaiText="Harap bersabar sementara kami mengarahkan Anda"
            fontSize="15px"
            color="#000"
          />
        </div>
      )}
    </CardWrapper>
  );
};

export default IdrPaymentMethodSelectCard;
